import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/auth/AuthContext';

const RoleRoute = ({ children, onlyAdmin = false, onlyUser = false }) => {
  const { user } = useAuth();

  if (onlyAdmin && !user?.is_superuser) {
    return <Navigate to="/" replace />;
  }

  if (onlyUser && user?.is_superuser) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleRoute;
